// extracted by mini-css-extract-plugin
export var animationContainer = "_jm-0";
export var footer = "_jm-1";
export var gray = "_jm-2";
export var lineItem = "_jm-3";
export var lineItemImage = "_jm-4";
export var lineItemInfo = "_jm-5";
export var lineItemText = "_jm-6";
export var lineItems = "_jm-7";
export var modalContent = "_jm-8";
export var options = "_jm-9";
export var orderName = "_jm-a";
export var refundAmount = "_jm-b";